module.exports = __webpack_public_path__ + "static/media/ERA.6d7ab132.svg";